import { useSelector } from '@xstate/react';
import usePolarisActor from 'src/hooks/usePolarisActor';

import type { ITreatmentInterviewMachineState } from '../machine/types';

const treatmentTransitionSelector = (state: ITreatmentInterviewMachineState) => {
  const isDxocTransition = state.matches('transitioningToDxoc');
  const isSymptomsTransition = state.matches('transitioningToSymptomsMI');
  const target = state.context.nextInterviewId;
  return {
    shouldTransition: isDxocTransition || isSymptomsTransition,
    target,
  };
};

const useTreatmentTransition = () => {
  const actor = usePolarisActor();

  return useSelector(actor as any, treatmentTransitionSelector);
};

export default useTreatmentTransition;
